define(
    'NetSuite.SuiteCommCPQ.ConfirmationModal',
    ['jQuery', 'Backbone', 'confirmation_modal.tpl'],
    function($, Backbone, confirmation_modal_tpl) {
        var ConfirmationModalView = Backbone.View.extend({
            template: confirmation_modal_tpl,
            events: {
                'click [data-action]':
                    function (event) {
                        this.response ($(event.currentTarget).attr('data-action'));
                    },
                'click [data-cancel-action]':
                    function () {
                        this.response (false);
                    }
            },
            initialize: function(params) {
                var _this = this;
                this.callback = params.callback;
                this.context = {
                    body: params.body || '',
                    variants: params.variants,
                    cancelText: params.cancelText || 'Cancel'
                };
                this.once("afterViewRender", function() {
                    _this.$containerModal.on("shown.bs.modal", function() {
                        _this.$containerModal.off("shown.bs.modal");
                        _this.$('[data-action]:first').focus();
                    })
                });
            },
            getContext: function() {
                return this.context;
            },
            response: function(confirmation) {
                this.callback && this.callback(confirmation);
                this.$containerModal.removeClass("fade").modal("hide").data("bs.modal", null);
            }
        });
        return ConfirmationModalView;
    });
